import React, { useState } from "react";

const MaintenanceAlertBanner = ({
  message = "Il sito è regolarmente attivo. Si avvisa che il giorno 2 Ottobre dalle ore 20:00 alle 24:00 sarà effettuata una manutenzione programmata.",
  expireAt,
}) => {
  // Controlla se l'utente ha chiuso il banner per la sessione corrente
  const [isDismissed, setIsDismissed] = useState(() => {
    try {
      return sessionStorage.getItem("pegaso_maintenance_banner_dismissed") === "true";
    } catch (e) {
      return false;
    }
  });

  // Se è stato chiuso per questa sessione o se non c'è messaggio, non renderizzare
  if (isDismissed || !message) {
    return null;
  }

  // Verifica scadenza (se specificata come stringa ISO, data o timestamp)
  if (expireAt) {
    const expireTime = new Date(expireAt).getTime();
    if (!isNaN(expireTime) && Date.now() >= expireTime) {
      return null;
    }
  }

  const handleClose = () => {
    try {
      sessionStorage.setItem("pegaso_maintenance_banner_dismissed", "true");
    } catch (e) { }
    setIsDismissed(true);
  };

  return (
    <>
      <style>
        {`
          @keyframes noticeSlideDown {
            0% {
              opacity: 0;
              transform: translate(-50%, -20px) scale(0.96);
            }
            100% {
              opacity: 1;
              transform: translate(-50%, 0) scale(1);
            }
          }

          .maintenance-banner-container {
            position: fixed;
            top: 16px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 999999;
            max-width: 92vw;
            width: fit-content;
            animation: noticeSlideDown 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
            pointer-events: none;
          }

          .maintenance-banner-card {
            pointer-events: auto;
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 8px 16px 8px 16px;
            border-radius: 9999px;
            background: rgba(15, 23, 42, 0.94);
            backdrop-filter: blur(16px);
            -webkit-backdrop-filter: blur(16px);
            border: 1px solid rgba(59, 130, 246, 0.4);
            box-shadow: 
              0 16px 32px -6px rgba(0, 0, 0, 0.55),
              0 0 20px 0 rgba(59, 130, 246, 0.15),
              inset 0 1px 1px 0 rgba(255, 255, 255, 0.12);
            color: #f8fafc;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
            transition: transform 0.2s ease, box-shadow 0.2s ease;
          }

          .maintenance-banner-card:hover {
            transform: translateY(-2px);
            border-color: rgba(59, 130, 246, 0.6);
            box-shadow: 
              0 20px 36px -6px rgba(0, 0, 0, 0.65),
              0 0 24px 0 rgba(59, 130, 246, 0.25),
              inset 0 1px 1px 0 rgba(255, 255, 255, 0.18);
          }

          .maintenance-badge-wrapper {
            display: flex;
            align-items: center;
            gap: 6px;
            background: linear-gradient(135deg, rgba(59, 130, 246, 0.25) 0%, rgba(37, 99, 235, 0.35) 100%);
            border: 1px solid rgba(96, 165, 250, 0.5);
            padding: 4px 10px;
            border-radius: 9999px;
            font-size: 11px;
            fontWeight: 700;
            letter-spacing: 0.5px;
            text-transform: uppercase;
            color: #93c5fd;
            flex-shrink: 0;
          }

          .maintenance-active-dot {
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background-color: #22c55e;
            box-shadow: 0 0 8px #22c55e;
          }

          .maintenance-text {
            font-size: 13.5px;
            font-weight: 500;
            color: #f1f5f9;
            letter-spacing: -0.1px;
            line-height: 1.4;
            text-align: left;
          }

          .maintenance-close-btn {
            background: rgba(255, 255, 255, 0.08);
            border: 1px solid rgba(255, 255, 255, 0.12);
            color: #cbd5e1;
            cursor: pointer;
            width: 26px;
            height: 26px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0;
            margin-left: 6px;
            flex-shrink: 0;
            transition: all 0.2s ease;
          }

          .maintenance-close-btn:hover {
            background: rgba(239, 68, 68, 0.25);
            border-color: rgba(239, 68, 68, 0.5);
            color: #ffffff;
            transform: scale(1.08);
          }

          @media (max-width: 640px) {
            .maintenance-banner-container {
              top: 12px;
              width: 95vw;
            }
            .maintenance-banner-card {
              border-radius: 20px;
              padding: 10px 14px;
              gap: 8px;
              flex-wrap: wrap;
              justify-content: center;
              text-align: center;
            }
            .maintenance-text {
              font-size: 12.5px;
              text-align: center;
            }
          }
        `}
      </style>

      <div className="maintenance-banner-container">
        <div className="maintenance-banner-card">
          <div className="maintenance-badge-wrapper">
            <span className="maintenance-active-dot" />
            <span>Promemoria</span>
          </div>

          <div className="maintenance-text">
            {message}
          </div>

          <button
            onClick={handleClose}
            className="maintenance-close-btn"
            title="Chiudi avviso"
          >
            <svg
              width="13"
              height="13"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
      </div>
    </>
  );
};

export default MaintenanceAlertBanner;
